import React, { FC } from "react";

const Document: FC = () => {
    return (
        <svg
            id="gearIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 33.28 33.28"
            width="32"
            height="32"
        >
            <path
                d="M29.82,18.36v-3.44l2.82-2.54q-.83-2.01-1.67-4.03l-3.79.19c-.97-.97-1.46-1.46-2.43-2.43l.19-3.79q-2.01-.83-4.03-1.67l-2.54,2.82h-3.44l-2.54-2.82q-2.01.83-4.03,1.67l.19,3.79c-.97.97-1.46,1.46-2.43,2.43l-3.79-.19-1.67,4.03,2.82,2.54v3.44l-2.82,2.54q.83,2.01,1.67,4.03l3.79-.19c.97.97,1.46,1.46,2.43,2.43l-.19,3.79q2.01.83,4.03,1.67l2.54-2.82c1.37,0,2.07,0,3.44,0l2.54,2.82q2.01-.83,4.03-1.67l-.19-3.79c.97-.97,1.46-1.46,2.43-2.43l3.79.19q.83-2.01,1.67-4.03l-2.82-2.54ZM16.64,26c-5.17,0-9.36-4.19-9.36-9.36s4.19-9.36,9.36-9.36,9.36,4.19,9.36,9.36-4.19,9.36-9.36,9.36Z"
                style={{
                    fill: "none",
                    stroke: "#333f48",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.28px"
                }}
            />
            <path
                d="M14.46,16.64v-4.28c0-.14.16-.22.27-.14l5.85,4.28c.09.07.09.21,0,.28l-5.85,4.28c-.11.08-.27,0-.27-.14v-4.28Z"
                style={{
                    fill: "#333f48",
                    stroke: "#333f48",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.28px"
                }}
            />
        </svg>
    );
};

export default React.memo(Document);
